import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {LocalStorage} from '../../storage.class';
import {CodaltComponent} from '../../codalt.component';
import {LoginFormState} from '../login-form-state.enum';
import {AuthService} from '../../services/auth/auth.service';
import {debounceTime, first, startWith} from 'rxjs/operators';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';

@Component({
    selector: 'app-link-login',
    templateUrl: './link-login.component.html',
    styleUrls: ['./link-login.component.scss'],
    imports: [
        ReactiveFormsModule,
        MatButton,
        MatIcon
    ]
})
export class LinkLoginComponent extends CodaltComponent implements OnInit, OnDestroy {

    LoginFormState = LoginFormState;
    isDvds = false;

    loginFormState: LoginFormState = LoginFormState.FillIn;
    errorMessage = null;
    fcCode: FormControl = new FormControl(null, [Validators.pattern(/[0-9]+/)]);

    loginForm = new FormGroup<{
        email: AbstractControl,
        code: AbstractControl,
    }>({
        email: new FormControl(LocalStorage.getMail(), [Validators.required, Validators.email]),
        code: this.fcCode
    });

    checkComplete = false;

    constructor(
        private authService: AuthService,
        private confirmDialogService: ConfirmDialogService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        super();
        this.subscriptions.add(this.loginForm.valueChanges.subscribe(() => {
            LocalStorage.setMail(this.loginForm.value.email);
        }));
        this.subscriptions.add(
            this.loginForm.get('email').valueChanges.subscribe((val: string) => {
                if (val.indexOf(' ') !== -1) {
                    this.loginForm.get('email').setValue(val.replace(' ', ''));
                }
            })
        );
    }

    ngOnInit() {
        this.subscriptions.add(this.activatedRoute.params.pipe(first()).subscribe((params) => {
            if (params['token'] && params['token'].length > 20) {
                LocalStorage.setUserToken(params['token']);
                if (params['millId']) {
                    this.router.navigate(['/asphalt-order-list', params['millId'], params['date']]);
                } else {
                    this.router.navigate(['/print', params['date']]);
                }
            }
        }));
        this.subscriptions.add(
            this.loginForm.get('email').valueChanges.pipe(debounceTime(200), startWith(this.loginForm.get('email').value)).subscribe(email => {
                this.checkLoginType();
            })
        );
    }

    checkLoginType(event?: any) {
        event?.stopPropagation();
        this.checkComplete = false;
        if (this.loginForm.get('email').valid) {
            this.subscriptions.add(
                this.authService.loginType(this.loginForm.get('email').value).subscribe(type => {
                    this.isDvds = this.loginForm.get('email').value?.trim().toLowerCase().endsWith('@dvds.nl');
                    this.checkComplete = true;
                    if (event) {
                        this.login();
                    }
                }, () => {
                    this.checkComplete = true;
                })
            );
        }
    }

    login() {
        if (this.checkComplete && this.loginFormState !== LoginFormState.Login) {
            this.errorMessage = null;

            if (this.loginFormState === LoginFormState.FillIn) {
                this.loginFormState = LoginFormState.Login;
                this.subscriptions.add(
                    this.authService.loginEmail(this.loginForm.value.email).subscribe(
                        () => {
                            this.loginFormState = LoginFormState.Send;
                        }, failReason => {
                            if (failReason?.status === 404) {
                                this.confirmDialogService.confirm(
                                    'Je hebt nog geen account',
                                    `Er bestaat geen account voor het e-mailadres <b>${this.loginForm.value.email}</b>.<br> Probeer het opnieuw of vraag een account aan.`,
                                    'Opnieuw proberen',
                                    'Account aanmaken').then(() => {
                                    this.loginFormState = LoginFormState.FillIn;
                                }, () => {

                                });
                            } else {
                                this.errorMessage = failReason.message;
                                if (!this.errorMessage) {
                                    this.errorMessage = 'Kon de server niet bereiken';
                                }
                                this.loginFormState = LoginFormState.Error;
                            }
                        })
                );
            }
        }
    }

    @HostListener('document:keypress', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if ((event.target as HTMLElement).nodeName.toLowerCase() === 'input') {
            return;
        }

        if (this.loginFormState === LoginFormState.Send) {
            if (!Number.isNaN(+event.key)) {
                this.fcCode.setValue(
                    (this.fcCode.value || '') + '' + event.key
                );
            }
        }
    }

    loginWithMicrosoft() {
        this.subscriptions.add(this.authService.loginWithMicrosoft().subscribe(response => {
            if (response.auth_url) {
                window.location.href = response.auth_url;
            }
        }, error => {
            this.errorMessage = 'Microsoft login is momenteel niet beschikbaar';
        }));
    }
}
